export const SETUP_AGENT_STORAGE_PREFIX = 'CL_CAMPAIGN_SETUP_AGENT_STORAGE_CARD';
